import type { ProgramNewsReview } from "@/services/adminProgramNews";
import { formatDate } from "./formatters";

interface OtherReviewsProps {
  reviews: ProgramNewsReview[];
}

/** Teammates' reviews, read-only. */
const OtherReviews = ({ reviews }: OtherReviewsProps) => {
  if (reviews.length === 0) return null;
  return (
    <div className="space-y-2">
      <h5 className="text-sm font-medium">Other reviews</h5>
      <ul aria-label="Other reviews" className="space-y-2">
        {reviews.map(review => (
          <li key={review._id} className="rounded-md border p-2 text-sm">
            <div className="flex flex-wrap gap-x-2 text-xs text-muted-foreground">
              <span>{review.reviewerEmail}</span>
              <span>{review.verdict === "right" ? "Right call" : "Wrong call"}</span>
              {review.correctClass ? <span>should be {review.correctClass}</span> : null}
              <span>{formatDate(review.updatedAt)}</span>
            </div>
            {review.critique ? <p className="mt-1 whitespace-pre-wrap">{review.critique}</p> : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OtherReviews;
